<script>
import baseMixin from '@mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'
import { highlightText } from '@/helpers/search-helpers'
export default {
  name: 'ClientDetails',
  mixins: [baseMixin],
  props: {
    clientId: {
      type: Number,
      default: -1,
    },
    locationId: {
      type: Number,
      default: -1,
    },
    groupId: {
      type: Number,
      default: -1,
    },
    locationTitle: {
      type: String,
      default: null,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      title: { Name: 'Loading Name' },
    }
  },
  computed: {
    ...mapGetters({
      getClient: 'client/getClient',
      getLocation: 'client/getLocation',
      getGroup: 'client/getGroup',
    }),
    location() {
      return this.getLocation(this.locationId)
    },
    getClientIdFromLocation() {
      if (!this.location || !this.location?.values?.ClientID) return ''
      return this.location.values.ClientID
    },
    getTitle: function () {
      if (this.clientId > -1) {
        return this.getClient(this.clientId).name
      }
      if (this.groupId > -1) {
        return this.getGroup(this.groupId).name
      }
      if (this.locationId > -1 || this.locationTitle) {
        return this.locationTitle || this.location.name
      }
      return ''
    },
    getClassType: function () {
      if (this.clientId > -1) {
        return 'CLIENT'
      }
      if (this.groupId > -1) {
        return 'GROUP'
      }
      if (this.locationId > -1) {
        return 'LOCATION'
      }
      return 'CLIENT'
    },
    getClass: function () {
      // clientId   -
      // locationId -
      // groupId    -
      var additionalClass = 'unspecified'
      if (this.clientId > -1) {
        additionalClass = 'client'
      }
      if (this.groupId > -1) {
        additionalClass = 'group'
      }
      if (this.locationId > -1) {
        additionalClass = 'location'
      }
      return additionalClass + ' clientInfo'
    },
  },
  mounted() {
    this.refreshContent()
  },
  updated() {
    this.refreshContent()
  },
  methods: {
    highlightText,
    refreshContent: function () {
      switch (this.returnClassType()) {
        case 'CLIENT':
          this.pokeClient(this.clientId).then((response) => {})
          break
        case 'LOCATION':
          this.pokeLocation(this.locationId).then((response) => {})
          break
        case 'GROUP':
          this.pokeGroup(this.groupId).then((response) => {})
          break
      }
    },
    getHref: function () {
      if (this.groupId > -1) {
        return this.returnClientGroupUrl(this.groupId)
      }
      if (this.locationId > -1) {
        return this.returnLocationUrl(
          this.getClientIdFromLocation,
          this.locationId
        )
      }
      return this.returnClientUrl(this.clientId)
    },
    returnClassType: function () {
      if (this.clientId > -1) {
        return 'CLIENT'
      }
      if (this.groupId > -1) {
        return 'GROUP'
      }
      if (this.locationId > -1) {
        return 'LOCATION'
      }
      return 'CLIENT'
    },
    ...mapActions({
      pokeClient: 'client/pokeClient',
      pokeLocation: 'client/pokeLocation',
      pokeGroup: 'client/pokeGroup',
    }),
  },
}
</script>

<template>
  <span @click.stop>
    <a class="clientInfoLink" :href="getHref()" target="_blank">
      <v-chip
        class="my-2 mr-2 max-width-chip client-chip"
        :color="isDarkMode ? 'grey lighten-1' : 'white'"
        :text-color="isDarkMode ? '' : 'grey darken-4'"
      >
        <v-avatar
          left
          :class="[isDarkMode ? 'grey darken-1' : 'grey lighten-5']"
        >
          <div style="font-size: 0.75em">{{ getClassType[0] }}</div>
        </v-avatar>
        <span v-sanitized-html="highlightText(getTitle, search)"></span>
      </v-chip>
    </a>
  </span>
</template>

<style lang="scss" scoped>
.clientInfoLink {
  text-decoration: none;
}
.clientInfo {
  display: inline-block;
  padding: 5px 10px 5px 10px;
  margin: 3px;
  text-decoration: none;
  border-radius: 10px;
}

.client-chip {
  text-decoration: none;
  cursor: pointer;
  .v-chip__content {
    text-decoration: none;
  }
}

.client-chip:hover {
  background-color: lightgrey;
}

.client {
  background-color: rgb(34, 73, 179);
}
.group {
  background-color: rgb(231, 109, 255);
}
.location {
  background-color: rgb(139, 223, 139);
}
.unspecified {
  background-color: rgb(200, 110, 100);
}
.max-width-chip.v-chip {
  max-width: calc(100% - 16px);
}

.max-width-chip .v-chip__content {
  position: relative;
  display: inline-block !important;
  padding-right: 30px !important;
  overflow: hidden;
  line-height: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.max-width-chip .v-chip__close {
  position: absolute;
  top: 5px;
  right: 0;
  width: 24px;
}
</style>
